import React from "react";
import "../css/ImpactStories.css";

const ImpactStories = () => {
  return (
    <div className="impact-stories-container">
      {}
      <h2 className="stories-main-title">Our Impact & Stories</h2>

      {}
      <div className="stories-video-grid">
        {}
        <div className="yt-card-frame gradient-orange-glow">
          {}
          <div className="yt-header-overlay">
            <div className="yt-avatar avatar-orange-fill">B</div>
            <div className="yt-text-meta">
              <h4 title="Placeholder Video">Placeholder Video</h4>
              <p>BenMarquezTX</p>
            </div>
          </div>

          {}
          <div className="yt-middle-play-trigger">
            <div className="yt-red-button-shape">
              <span className="yt-triangle-icon"></span>
            </div>
          </div>

          {}
          <div className="yt-footer-overlay">
            <div className="yt-left-pills">
              {}
              <button className="yt-pill-circle" title="Share">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                  <polyline points="16 6 12 2 8 6" />
                  <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
              </button>
              {}
              <button className="yt-pill-circle" title="Watch Later">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </button>
            </div>

            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noreferrer"
              className="yt-watch-brand-link"
            >
              Watch on <span className="yt-bold-logo">▶ YouTube</span>
            </a>
          </div>
        </div>

        {}
        <div className="yt-card-frame image-cinematic-bg">
          {}
          <div className="yt-header-overlay">
            <div className="yt-avatar avatar-profile-mock"></div>
            <div className="yt-text-meta">
              <h4 title="Charlie Puth - We Don't Talk Anymore (">
                Charlie Puth - We Don't Talk Anymore (
              </h4>
              <p>Charlie Puth</p>
            </div>
          </div>

          {}
          <div className="yt-middle-play-trigger">
            <div className="yt-red-button-shape">
              <span className="yt-triangle-icon"></span>
            </div>
          </div>

          {}
          <div className="yt-footer-overlay">
            <div className="yt-left-pills">
              {}
              <div className="yt-brand-pill-badge">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9v-4h2v4zm0-6H9V8h2v2zm4 6h-2v-4h2v4zm0-6h-2V8h2v2z" />
                </svg>
              </div>
              <button className="yt-pill-circle" title="Watch Later">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </button>
            </div>

            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noreferrer"
              className="yt-watch-brand-link"
            >
              Watch on <span className="yt-bold-logo">▶ YouTube</span>
            </a>
          </div>
        </div>
      </div>

      {}
      <p className="stories-bottom-caption">
        Your contributions help us reach more people in need around the world.
      </p>
    </div>
  );
};

export default ImpactStories;
